// extracted by mini-css-extract-plugin
module.exports = {"locationInput":"SearchLocationInput_locationInput__1DLk_"};